import React, { useEffect, useMemo } from 'react';
import { useForm } from 'react-hook-form';
import Button from '@mui/material/Button';
import { PillButton, ControlledTextField } from '@zz2/zz2-ui';
import { ControlledLabelledCheckBox } from '../../../../components/input/form/ControlledLabelledCheckBoxWrapper';
import { yupResolver } from '@hookform/resolvers/yup';
import { IMaterialCostFormValues } from '../../../../@types/model/masterData/materialCost/materialCostFormValues';
import MaterialCostModelHelper from '../../../../@types/model/masterData/materialCost/materialCostModelHelper';
import CustomReactHookFormDevTools from '../../../../components/devtools/ReactHookFormDevTools';

interface IMaterialCostFormProps {
    isLoading : boolean;
    initialValues : IMaterialCostFormValues;
    onSubmit : (values : IMaterialCostFormValues) => void;
    onClose : () => void;
}

const MaterialCostForm = (props : IMaterialCostFormProps) : React.ReactElement => {
    const { handleSubmit, control, formState: { isValid, isDirty }, trigger, getValues } = useForm<IMaterialCostFormValues>({
        defaultValues: props.initialValues,
        resolver: yupResolver(MaterialCostModelHelper.formSchema()),
        mode: 'onChange',
    });

    /*================================================================================================================
     *                                                  Effects
     * ==============================================================================================================*/

    useEffect(() => {
        trigger();
    }, []);

    /*================================================================================================================
     *                                                  Async Methods
     * ==============================================================================================================*/

    /*================================================================================================================
     *                                                  Handler Methods
     * ==============================================================================================================*/

    const onSubmit = () : void => {
        props.onSubmit(getValues());
    };

    /*================================================================================================================
     *                                                  Memos
     * ==============================================================================================================*/

    /*================================================================================================================
     *                                                  Render Methods
     * ==============================================================================================================*/

    return (
        <div>
            <form onSubmit={handleSubmit(props.onSubmit)}>
                <div className={'fdc p30'}>
                    <ControlledTextField
                        className={'mb20'}
                        control={control}
                        label={'New Amount (in Rand)'}
                        name={'amount'}
                        type={'number'}
                        size={'small'}
                    />
                    <div className={'flx1 fdr jcfs'}>
                        <ControlledLabelledCheckBox
                            label={'Currently Active?'}
                            name={'currentlyActive'}
                            control={control}
                            defaultValue={props.initialValues.currentlyActive}
                        />
                        <div className={'w10'}/>
                        <ControlledLabelledCheckBox
                            label={'Active?'}
                            name={'isActive'}
                            control={control}
                            defaultValue={props.initialValues.isActive}
                        />
                    </div>
                    <div className={'fdr flx1 aic jcfe'}>
                        <Button className={'cpd mr20'} type={'button'} onClick={props.onClose}>
                            CANCEL
                        </Button>
                        <PillButton
                            className={'pl30 pr30'}
                            text={'SAVE'}
                            size={'small'}
                            color={'secondary'}
                            disabled={ !isDirty || !isValid || props.isLoading }
                            onClick={onSubmit}
                        />
                    </div>
                </div>
            </form>
            <CustomReactHookFormDevTools control={control} />
        </div>
    );
};

export default MaterialCostForm;
